import SoulmateImage from "@/assets/img/modal/soulmate_sketch_step0_head.webp"
import { SOULMATE_REPORT_MODAL_V2_PLAN_ID } from "@/features/subscriptions/report-plan-codes"
import { ReportIds } from "@/features/today/config/reports-data"

import type { AppModalComponentProps } from "../config/modal-registry"
import { ReportPromoModalV2, type ReportPromoCopyV2 } from "./report-promo-modal-v2"

const COPY: ReportPromoCopyV2 = {
  reportId: ReportIds.Soulmate,
  planId: SOULMATE_REPORT_MODAL_V2_PLAN_ID,
  title: "Get Your Soulmate Sketch",
  description: "See a personalized sketch of the face the stars may be guiding toward your path",
  image: SoulmateImage,
  imageClassName: "mb-[-32px] h-[364px]",
  flushTop: true,
}

export function ReportSoulmateSketchModalV2(props: AppModalComponentProps) {
  return <ReportPromoModalV2 {...props} copy={COPY} />
}
